import { Component, Input, Output, ViewChild, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { AlertService } from './alert.service';
import { APIService } from './api.service';
import { DataService } from './data.service';
import { Player } from './Main.Model';
import { HomeService } from './Main.service';
import { SideBarComponent } from './side-bar/side-bar.component';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent {

  title: string = 'RNZ';
  GalleryFolderIndex: number = 0;
  SelectedFolder: [] = [];

  constructor(public APIService: APIService, public DataService: DataService, public AlertService: AlertService) {   }
  
  async ngOnInit() {
    this.DataService.getInitialData();//gets settings
    //this.APIService.GetUserIp("", this.DataService.SelectedTorn);
    await this.DataService.refreshPlayers();
    //this.cookieService.set('cookie-name', 'our cookie value', this.add_years(new Date(), -1));
    if (!this.DataService.LoggedInUser || this.DataService.LoggedInUser.name == 'Login') {
      await this.DataService.LogUserInFromCookie();
    }
  }

  SelectGalleryFoldersIndexEmit(event: any) {
    this.SelectedFolder = event;
  }

   MainStatusEmit(event: any) {
    this.DataService.MainStatus = event;
   }

  //  PlayerHistoryEmit(event) {
  //   this.DataService.MainStatus = 'History';
  //  }

}
